var exports = {
  "wm": "xe7b6e3d6--10c6b5--logo",
  "yr": "xe7b6e3d6--10c6b5--logo-image",
  "_j": "xe7b6e3d6--10c6b5--logo-default",
  "Gp": "xe7b6e3d6--10c6b5--logo-default-content",
};

module.exports = exports;
